import React from 'react';

import EmptyList from '../useful/EmptyList';
import CardItem from './CardItem';
import eventIconYellowCard from '../../images/event_yellow_card.png'
import eventIconRedCard from '../../images/event_red_card.png'

const Cards = (props) => {

    const { teams, players } = props;

    const tableHead =
        <thead className="">
            <tr >
                <th className="text-center" style={{ width: 32 }}>#</th>
                <th className="pl-0" >NOMBRE</th>
                <th className="text-center" style={{ width: 15 }}>
                    <img className="ml-1 mr-1" src={eventIconYellowCard} height="18" alt="" />
                </th>
                <th className="text-center" style={{ width: 15 }}>
                    <img className="ml-1 mr-1" src={eventIconRedCard} height="18" alt="" />
                </th>
            </tr>
        </thead>

    const playersWithStatistics = (players || []).filter(item => {
        return item && item.position !== "Director Técnico" 
        && item.statistic 
        && (item.statistic.yellowCards || item.statistic.redCards);
    })

    playersWithStatistics.sort((a, b) => {
        const aCards = (a.statistic.yellowCards || 0) + (a.statistic.redCards || 0);
        const bCards = (b.statistic.yellowCards || 0) + (b.statistic.redCards || 0);

        return bCards - aCards || (b.statistic.redCards || 0) - (a.statistic.redCards || 0);
    })

    const listView = (playersWithStatistics.length > 0) ?
        playersWithStatistics.map((item, i) => {
            const team = teams.find(team => team.uid == item.teamUid);
            return (
                <CardItem key={i} item={item} team={team} />
            )
        })
        :
        <tr>
            <td colSpan="10"><EmptyList /></td>
        </tr>

    return (
        <div className="">
            <div className="row justify-content-between m-0 mb-2 small pt-1 pb-1">
                <span className="col-auto align-self-center font-weight-bolder m-0 p-0">
                    Tarjetas por jugador
                </span>
            </div>

            <div className="table-responsive-sm">
                <table className="table table-sm small ">
                    {tableHead}
                    <tbody>
                        {listView}
                    </tbody>
                </table>
            </div>

        </div>
    )

}

export default Cards;